module.exports = __webpack_public_path__ + "img/store_discounts.e44b5128.png";